<template>
  <div>
    <router-view />
  </div>
</template>

<script>
import top from "@/components/common/top.vue";
import navMenu from "@/components/common/navMenu.vue";
import Navbar from "@/components/space/Navbar";
import axios from "axios";
import { rand } from "../../api/http";
export default {
  data() {
    return {};
  },
  components: { top, navMenu, Navbar },
  created() {
    this.getRecordRjw(JSON.parse(localStorage.getItem("loginInfo")));
  },
  mounted() {
    if (!localStorage.getItem("getSpaceinfo")) {
      this.$router.push("/space/infomalloc");
    }
  },
  methods: {
    getRecordRjw(hh) {
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        localStorage.setItem(
          "space_traceid",
          JSON.stringify(
            `${hh.user_id}` +
              `${Number(Date.parse(new Date())) / 1000 + differenctime}` +
              `${rand(1000, 9999)}`
          )
        );
        // 进入空间
        var saydata = {//{dhahuhjsiaoyesytywjiyueguaiyoouuyyuooudhuegaungqourtgfse}
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "studyspace_entrance",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.user_nicename}` + "进入了网络学习空间",
          data: {
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id: hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("space_traceid")),
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },
  },
};
</script>

<style lang='less'>
</style>
